import React from "react";
import TerminaleCucina from "./TerminaleCucina";

const TerminalePizzeria = () => <TerminaleCucina station="pizza" />;
export default TerminalePizzeria;
